export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');


  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
    , detectIpad: IPADDETECTED
    // options
    , allEventsLink: true
    , allEventsLinkText: 'view all events'
    , hasImages: false
    , imageBackground: false
    , lazyLoadImages: true
    , buyNowButton: { visible: false, text: 'BUY NOW' }
    , moreButton: { visible: false, text: 'MORE' }
    , maxItemsVisible: 5
    , isResponsive: false
    , hasDescription: false
    , textContainer: true
    , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
    , attributeOrder: {
      1: 'image',
      2: 'date',
      3: 'title',
      4: 'description',
      5: 'buttons'
    }


    , multiFeatureLoaded: function (data) {



      // use function below if "more" text needs to appear at end of description text
      $('.featureItem ').wrapAll('<div class="wrap-event"></div>')

      $('#multiScheduleFeature .wrap-event .featureItem').each(function () {
        $(this).after('<span class="separator"></span>')
      })

      $('#multiScheduleFeature .featureItem').each(function (i) {
        $('.all-events-btn').addClass('button');

        let urlData = data[i].URL

        var itemDescripton = $(this).find('.featureItemTitle');
        var characterLimit = 35;
        var itemDescriptonText = itemDescripton.text();
        if (itemDescriptonText.length > characterLimit) {
          var trimmedText = itemDescriptonText.substring(0, characterLimit) + '...';
          itemDescripton.text(trimmedText);
        }

        if (urlData == "") {
          $(this).removeAttr('href')
        }
      });



    }
  });

};

